// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"RatingStars_ratingContainer__q4fVQ","stars":"RatingStars_stars__STVSx","starButton":"RatingStars_starButton__Y9GYf","label":"RatingStars_label__XR7f1"};